module.exports = __webpack_public_path__ + "img/start.6b725bc2.svg";